__turbopack_context__.v({
  "contentContainer": "ghWtta_contentContainer",
  "imageWrapper": "ghWtta_imageWrapper",
  "ringImage": "ghWtta_ringImage",
  "section": "ghWtta_section",
  "textContainer": "ghWtta_textContainer" + " " + __turbopack_context__.i(515534)["sectionTextBlock"],
});
